import React from "react";
import { useTranslation } from "react-i18next";

import "./AmpQuestions.css"

export interface AmpQuestionsProps {
    belowHeaderContent: JSX.Element;
    questions: Array<JSX.Element>;
}

export default function AmpQuestions(props: AmpQuestionsProps): JSX.Element{
    
    const {t} = useTranslation(['login']);

    return (
        <div className="amp-questions-top">
            <div className="amp-questions-icon">
                <img src="./images/Amp-q-mark.png" alt=""></img>
            </div>
            <div>
                <h2 className="amp-questions-heading" id="amp-questions">{t("have-qs") as string}</h2>
                {props.belowHeaderContent}
                {props.questions}
            </div>
        </div>
    )
}